import { render, staticRenderFns } from "./ListadoModulosTabla.vue?vue&type=template&id=33482568"
import script from "./ListadoModulosTabla.vue?vue&type=script&lang=js"
export * from "./ListadoModulosTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports